import { ReviewLoadingOnboarding } from "@/components/review-loading-onboarding";
import { BarLoader } from "@/toggle-ui-kit/loader";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const DEFAULT_TITLE = "화면 준비 중...";
const DEFAULT_MESSAGE = "화면을 준비하고 있습니다...";

export const PendingTabPage = () => {
  const [searchParams] = useSearchParams();
  const title = searchParams.get("title") ?? DEFAULT_TITLE;
  const message = searchParams.get("message") ?? DEFAULT_MESSAGE;
  const variant = searchParams.get("variant");

  useEffect(() => {
    document.title = title;
  }, [title]);

  // DSD 리뷰 준비 중 — 리뷰 페이지와 동일한 온보딩 캐러셀 로딩으로 이어지게
  if (variant === "dsd-review") {
    return (
      <main className="flex h-screen w-full flex-col items-center justify-center gap-2 bg-background-base px-6">
        <ReviewLoadingOnboarding />
        <BarLoader size="lg" color="#171717" />
      </main>
    );
  }

  return (
    <main className="flex h-screen w-full flex-col items-center justify-center gap-5 bg-background-base">
      <p className="body-2-normal-medium text-label-alternative">{message}</p>
      <BarLoader size="md" color="#171717" />
    </main>
  );
};
